const getCategoryResources = resources => {
    let categoryResources = {}

    resources.forEach(resource => {
        const { type, title, description, destination, path } = resource
        if (!categoryResources.hasOwnProperty(type)) {
            categoryResources[type] = []
        }
        categoryResources[type].push({
            '@id': resource['@id'] || null,
            type,
            title,
            path,
            description,
            destination: destination || '',
        })
    })

    return categoryResources
}

const setCategoryResources = resources => {
    let categoryResources = []

    if (resources) {
        for (let [type, values] of Object.entries(resources)) {
            values.forEach((value, idx) => {
                const { title, description, destination, path } = value
                const resourceData = {
                    path: path,
                    displayOrder: idx + 1,
                    title: title,
                    description: description,
                    destination: destination || '',
                }

                if (value['@id']) {
                    // Use resource IRI for existing resources
                    resourceData['@id'] = value['@id']
                } else {
                    // Set the type for new resources
                    resourceData.type = type
                }

                resourceData.type = type

                categoryResources.push(resourceData)
            })
        }
    }

    return categoryResources
}

export const formatDataForForm = data => {
    data.categoryResources = getCategoryResources(data.resources)

    return {
        ...data,
    }
}

export const formatDataForAPI = data => {
    const dataClone = { ...data }

    dataClone.name = data.heading || ''
    dataClone.options = {
        ...data.options,
        attributes: data?.options?.attributes?.filter(att => att.attribute.label),
    }

    dataClone.resources = setCategoryResources(dataClone.categoryResources)
    dataClone.facets = data.facets.map(facet => facet.code)
    dataClone.id = typeof data.id === 'string' ? parseInt(data.id?.split('/').pop()) : data.id

    // categoryResources are only used in the UI and don't need to be passed to the API
    delete dataClone.categoryResources

    return dataClone
}
